import templateUrl from 'emun.on-demand/admin/od-product-manager.htm'
import resolve from 'ioc/resolve'
import controller from 'emun.on-demand/admin/od-product-manager.controller'

let ProductManagerComponent = {
    bindings: {
        hideLeftNav: '@',
        panelMaxHeight: '@',
        panelType: '@',
        designId: '@',
        onPublish: '&',
        onSaved: '&'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default ProductManagerComponent;